import React, { useState } from 'react'
import { Tabs, TabPanel, LoadingSpinner } from '@paypalcorp/pp-react'

export default function Pills({ children }: any) {
  const [selection, setSelection] = useState(0)
  const [pills] = useState(
    children.map((child: any) => {
      return {
        label: child.props.label,
        id: child.props.label,
        panelId: child.props.label,
      }
    }),
  )
  const changeTabs = (e: any) => {
    const tabId = e.target.id
    pills.forEach((pill: any, index: number) => {
      if (pill.id === tabId) {
        setSelection(index)
      }
    })
  }

  return pills.length === 0 ? (
    <LoadingSpinner screenReaderText="loading" size="md" />
  ) : (
    <Tabs
      {...({ theme: 'v2' } as any)}
      name="TabsGroup1"
      selectedTabIdx={selection}
      tabs={pills}
      onClick={changeTabs}
      className="ui-tabs"
    >
      {children.map((child: any) => {
        return (
          <TabPanel
            id={child.props.label}
            tabId={child.props.label}
            key={child.props.label}
          >
            {child.props.children}
          </TabPanel>
        )
      })}
    </Tabs>
  )
}
